'use strict';

const menuItems = [
  {
    page: 'home',
    key: 'HomeLinkText',
    routeKey: 'home',
  },
  {
    page: 'categories',
    key: 'CategoriesLinkText',
    routeKey: 'category',
  },
  {
    page: 'themed-page',
    routeKey: 'themed_page',
  },
  {
    page: 'top-offers',
    key: 'TopVouchersLinkText',
    routeKey: 'top_offers',
  },
  {
    page: 'exclusive-offers',
    key: 'ExclusiveOffersLinkText',
    routeKey: 'exclusive_offers',
  },
];

function getMainNavigationItems({
  activePage,
  routes,
  themedPage,
  showTopOffers,
}) {
  const navItems = menuItems.reduce((menu, item) => {
    if (item.page === 'top-offers' && !showTopOffers) {
      return menu;
    }

    if (item.page === 'themed-page') {
      if (!themedPage) {
        return menu;
      }

      item.linkText = themedPage.title;
      item.href = routes['themed_page'].show.replace(
        '{eventSlug}',
        themedPage.slug
      );
    }

    menu.push({
      ...item,
      href: item.href ? item.href : routes[item.routeKey].main,
      active: activePage === item.page ? 'active' : '',
    });

    return menu;
  }, []);

  return navItems;
}

module.exports.getMainNavigationItems = getMainNavigationItems;
